import React from 'react';

import { TableCellProps } from './TableCell';
export interface TableRowProps extends React.HTMLProps<HTMLTableRowElement> {
  /** Child of `Table.Row` which should be one or more `Table.Cell`. */
  children:
    | React.ReactElement<TableCellProps>
    | React.ReactElement<TableCellProps>[];
}

export const TableRow: React.FC<TableRowProps> = ({
  children,
  className,
  ...rest
}) => <tr {...rest}>{children}</tr>;

export default TableRow;
